import React from 'react';
import ReactPlayer from "react-player";
import './VideoPresent.css';
import Popup from './Popup/Popup.jsx'

export default class VideoPresent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: true,
    }

    this.showSpeakers = this.showSpeakers.bind(this);
  }

  showSpeakers() {
    this.setState({hide: !this.state.hide});
  }

  renderVideoPresent(item, i) {
    return (
      <>
      {item.two_person === undefined && <div className="videoPresent_item">
         <div className='videoPresent_item-info_wrap'>
         {item.track && <div className="speakers_track">{item.track}</div>}
            <div className='videoPresent_item-video'>
            {item.video && <ReactPlayer
              url={item.video}
              width="100%"
              height="100%"
              playing
              controls
              playIcon={<button className='videoPresent_item-play'></button>}
              light={item.photo}
            />}
            {!item.video && 
              <img src={item.photo} alt="" />
            }
            </div>
            <div className='videoPresent_item-content'>
                <p className="videoPresent_item_name">{item.name}</p>
                <p className="videoPresent_item_position">{item.position}</p>
                <div className='videoPresent_social_link'>
                    {item.tw && <a className='social_link social_tw' target='_blank' rel="noreferrer" href={item.tw}></a>}
                    {item.github && <a className='social_link social_github' target='_blank' rel="noreferrer" href={item.github}></a>}
                    {item.ln && <a className='social_link social_ln' target='_blank' rel="noreferrer" href={item.ln}></a>}
                    {item.fb && <a className='social_link social_fb' target='_blank' rel="noreferrer" href={item.fb}></a>}
                    {item.website && <a className='social_link social_website' target='_blank' rel="noreferrer" href={item.website}></a>}
                    {item.website1 && <a className='social_link social_website' target='_blank' rel="noreferrer" href={item.website1}></a>}
                    {item.website2 && <a className='social_link social_website' target='_blank' rel="noreferrer" href={item.website2}></a>}
                    {item.inst && <a className='social_link social_inst' target='_blank' rel="noreferrer" href={item.inst}></a>}
                    {item.yb && <a className='social_link social_yb' target='_blank' rel="noreferrer" href={item.yb}></a>}
                </div>
                <img className='videoPresent_company_logo' src={item.logo} alt="" />
                <p className='videoPresent_title'>"{item.title}"</p>
                <Popup abstract={item.abstract} title={item.title} bio={item.bio} key={i} />
            </div>
        </div>
      </div>}
      {item.two_person === true && <div className="videoPresent_item">
         <div className='videoPresent_item-info_wrap'>
            <div className="speakers_track">{item.track}</div>
           <div className='videoPresent_video videoPresent_video_2'>
              <div className='videoPresent_item-video videoPresent_item-video2'>
              {item.video && <ReactPlayer
                url={item.video}
                width="100%"
                height="100%"
                playing
                controls
                playIcon={<button className='videoPresent_item-play'></button>}
                light={item.photo}
              />}
              {!item.video && 
                <img src={item.photo} alt="" />
              }
              </div>
              <div className='videoPresent_item-video videoPresent_item-video2'>
              {item.video2 && <ReactPlayer
                url={item.video2}
                width="100%"
                height="100%"
                playing
                controls
                playIcon={<button className='videoPresent_item-play'></button>}
                light={item.photo2}
              />}
              {!item.video2 && 
                <img src={item.photo2} alt="" />
              }
              </div>
            </div>
            <div className='videoPresent_item-content'>
              <div className='video_info_block'>
                <div className='video_info_item video_info_item1'>
                  <p className="videoPresent_item_name videoPresent_item_name2">{item.name}</p>
                  <p className="videoPresent_item_position videoPresent_item_position2">{item.position}</p>
                  <div className='videoPresent_social_link'>
                      {item.tw && <a className='social_link social_tw' target='_blank' rel="noreferrer" href={item.tw}></a>}
                      {item.github && <a className='social_link social_github' target='_blank' rel="noreferrer" href={item.github}></a>}
                      {item.ln && <a className='social_link social_ln' target='_blank' rel="noreferrer" href={item.ln}></a>}
                      {item.ln2 && <a className='social_link social_ln' target='_blank' rel="noreferrer" href={item.ln2 }></a>}
                      {item.fb && <a className='social_link social_fb' target='_blank' rel="noreferrer" href={item.fb}></a>}
                      {item.website && <a className='social_link social_website' target='_blank' rel="noreferrer" href={item.website}></a>}
                      {item.inst && <a className='social_link social_inst' target='_blank' rel="noreferrer" href={item.inst}></a>}
                  </div>
                  <img className='videoPresent_company_logo videoPresent_company_logo2' src={item.logo} alt="" />
                </div>
                <div className='video_popup_block'>
                  <p className='videoPresent_title'>"{item.title}"</p>
                  <Popup abstract={item.abstract} title={item.title} bio={item.bio} key={i} />
                </div>
                <div className='video_info_item video_info_item2'>
                  <p className="videoPresent_item_name videoPresent_item_name2">{item.name2}</p>
                  <p className="videoPresent_item_position videoPresent_item_position2">{item.position2}</p>
                  <div className='videoPresent_social_link'>
                      {item.tw2 && <a className='social_link social_tw' target='_blank' rel="noreferrer" href={item.tw2}></a>}
                      {item.github2 && <a className='social_link social_github' target='_blank' rel="noreferrer" href={item.github2}></a>}
                      {item.ln2 && <a className='social_link social_ln' target='_blank' rel="noreferrer" href={item.ln2}></a>}
                      {item.fb2 && <a className='social_link social_fb' target='_blank' rel="noreferrer" href={item.fb2}></a>}
                      {item.website2 && <a className='social_link social_website' target='_blank' rel="noreferrer" href={item.website2}></a>}
                      {item.inst2 && <a className='social_link social_inst' target='_blank' rel="noreferrer" href={item.inst2}></a>}
                  </div>
                  <img className='videoPresent_company_logo videoPresent_company_logo2' src={item.logo2} alt="" />
                </div>
              </div>
            </div>
        </div>
      </div>}
      </>
    )
  }

  render() {
      return (
          <div className="videoPresent">
              <div className='container VideoPresent_wrap'>
                  <div className="video_block">
                    {this.props.speakers.map((item, i) => <React.Fragment key={`videoPresent_item-${i}`}>{this.renderVideoPresent(item, i)}</React.Fragment>)}
                    {!this.state.hide && this.props.speakersHide.map((item, i) => <React.Fragment key={`videoPresent_item-${i}`}>{this.renderVideoPresent(item, i)}</React.Fragment>)}
                  </div>
                    <button className='video_btn' onClick={this.showSpeakers}>{this.state.hide ? 'Show more speakers' : 'Hide speakers'}</button>
              </div> 
          </div>
      )
  }
}